// ABOUTME: Reusable add/remove editor for a list of short string values (UoM ids, field names, allowed values).
import AddIcon from '@mui/icons-material/Add'
import {Box, Chip, IconButton, TextField} from '@mui/material'
import React, {useState} from 'react'

interface StringListEditorProps {
  values: string[]
  onChange: (next: string[]) => void
  placeholder?: string
  'data-cy'?: string
}

export const StringListEditor: React.FC<StringListEditorProps> = ({
  values,
  onChange,
  placeholder = 'Add value…',
  'data-cy': dataCy,
}) => {
  const [draft, setDraft] = useState('')

  const add = () => {
    const value = draft.trim()
    if (!value || values.includes(value)) {
      setDraft('')
      return
    }
    onChange([...values, value])
    setDraft('')
  }

  const remove = (value: string) => onChange(values.filter((v) => v !== value))

  return (
    <Box data-cy={dataCy}>
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1}}>
        {values.length === 0 && (
          <span className="text-sm text-foreground_faded">None</span>
        )}
        {values.map((value) => (
          <Chip key={value} label={value} size="small" onDelete={() => remove(value)} />
        ))}
      </Box>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
        <TextField
          size="small"
          value={draft}
          placeholder={placeholder}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              add()
            }
          }}
        />
        <IconButton aria-label="add" size="small" onClick={add} style={{boxShadow: 'none'}}>
          <AddIcon fontSize="small" style={{color: '#016AD4'}} />
        </IconButton>
      </Box>
    </Box>
  )
}
